import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

export const app = initializeApp({
  apiKey: import.meta.env.VITE_FB_API_KEY,
  authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FB_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET,
  appId: import.meta.env.VITE_FB_APP_ID,
  measurementId: import.meta.env.VITE_FB_MEASUREMENT_ID,
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");

if (import.meta.env.VITE_USE_EMULATORS === "1") {
  // gRoast uses a project-unique 14xxx emulator block (see firebase.json + scripts/dev-emulators.sh)
  // to avoid colliding with the default ports other local Firebase projects use. Keep all three in sync.
  connectAuthEmulator(auth, "http://127.0.0.1:14099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 14080);
  connectStorageEmulator(storage, "127.0.0.1", 14199);
  connectFunctionsEmulator(functions, "127.0.0.1", 14001);
}
